var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplePay1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apple-pay 1",
    clipPath: "url(#clip0_1615_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.93782 14.3893C8.4323 13.7708 8.76781 12.9404 8.67938 12.0918C7.95554 12.1278 7.07222 12.5694 6.56084 13.1883C6.10163 13.7184 5.69525 14.5836 5.80123 15.3966C6.61367 15.4671 7.42553 14.9905 7.93782 14.3893Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.6701 15.5555C7.49008 15.4852 6.48676 16.2252 5.9232 16.2252C5.3594 16.2252 4.49643 15.5909 3.56308 15.608C2.34828 15.6259 1.22109 16.3127 0.604624 17.4051C-0.663333 19.5905 0.270018 22.8322 1.50303 24.6121C2.10178 25.4926 2.82349 26.4622 3.77431 26.4273C4.67272 26.3921 5.02488 25.8456 6.11688 25.8456C7.20814 25.8456 7.52535 26.4273 8.47634 26.4097C9.4626 26.3921 10.0792 25.5287 10.6779 24.6473C11.3648 23.6434 11.646 22.6742 11.6637 22.621C11.6459 22.6034 9.76194 21.8806 9.74446 19.7134C9.72666 17.8988 11.2237 17.0356 11.2941 16.9821C10.4489 15.7319 9.128 15.5909 8.6701 15.5555Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.9449 13.0996C21.5097 13.0996 23.2956 14.8675 23.2956 17.4415C23.2956 20.0247 21.4729 21.8018 18.8806 21.8018H16.0409V26.3177H13.9893V13.0996H18.9449ZM16.0409 20.0796H18.395C20.1813 20.0796 21.1979 19.1179 21.1979 17.4507C21.1979 15.7837 20.1813 14.831 18.4042 14.831H16.0409V20.0796Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.8317 23.5795C23.8317 21.8939 25.1232 20.8588 27.4135 20.7306L30.0514 20.5749V19.833C30.0514 18.7613 29.3278 18.1201 28.1189 18.1201C26.9735 18.1201 26.2591 18.6696 26.0852 19.5307H24.2166C24.3265 17.7902 25.8103 16.5078 28.192 16.5078C30.5278 16.5078 32.0208 17.7444 32.0208 19.6772V26.3183H30.1246V24.7336H30.079C29.5203 25.8054 28.3019 26.4831 27.0379 26.4831C25.1508 26.4831 23.8317 25.3106 23.8317 23.5795ZM30.0514 22.7093V21.949L27.6788 22.0955C26.4972 22.1781 25.8286 22.7002 25.8286 23.5246C25.8286 24.3672 26.5247 24.9169 27.5873 24.9169C28.9704 24.9168 30.0514 23.9641 30.0514 22.7093Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.811 29.8632V28.2601C33.9573 28.2967 34.287 28.2967 34.452 28.2967C35.3679 28.2967 35.8627 27.912 36.1648 26.9228C36.1648 26.9044 36.339 26.3365 36.339 26.3273L32.8583 16.6816H35.0015L37.4384 24.5228H37.4748L39.9117 16.6816H42L38.3906 26.8219C37.5665 29.1579 36.6138 29.9089 34.6169 29.9089C34.452 29.9089 33.9572 29.8906 33.811 29.8632Z",
    fill: "black"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1615_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePay1);
export default __webpack_public_path__ + "static/media/apple-pay 1.d3cbac8c32a56bf7ebee557f413b8d0c.svg";
export { ForwardRef as ReactComponent };